// extracted by css-extract-rspack-plugin
export default {"cls1":"SmallAccountMenuButton-cls1_vDE","cls2":"SmallAccountMenuButton-cls2_jIW SmallAccountMenuButton-cls1_vDE"};